module.exports = __webpack_public_path__ + "img/minus.f2deefda.svg";